var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dropdown',_vm._g(_vm._b({staticClass:"y-dropdown"},'el-dropdown',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_vm._t("dropdown",null,{"slot":"dropdown"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }